import { useColorModeValue, Flex, CloseButton, Icon, BoxProps, Box, Text, VStack } from "@chakra-ui/react"
import { NavItemProps, NavItems } from "../NavItems"
import { NavLink } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { Logo } from "../../../Logo";
import { selectNavigation } from "../../../store/slices/User/selectors";
import { useSelector } from "react-redux";

interface SidebarProps extends BoxProps {
  onClose: () => void
}

const DefaultNav = ({ onClose, ...rest }: SidebarProps) => {
  const navigation = useSelector(selectNavigation);
  const navigationPaths = navigation.map(nav => nav.path);
  const FilterNavItems = NavItems.filter(route => navigationPaths.includes(route.path));

  return (
    <Box
      transition="3s ease"
      bg={useColorModeValue('whiteAlpha.700', 'gray.900')}
      borderRight="1px"
      borderRightColor={useColorModeValue('gray.200', 'gray.700')}
      w={{ base: 'full', md: 60 }}
      pos="fixed"
      h="full"
      {...rest}>
      <Flex h={24} alignItems="center" mx="8" justifyContent={{base: 'space-between', md: 'center'}}>
        <VStack alignItems='center' gap={0}>
          <Logo />
          <Text fontSize="xs" fontWeight='bold' color='gray.500'>
            GUAYMAS
          </Text>
        </VStack>
        <CloseButton display={{ base: 'flex', md: 'none' }} onClick={onClose} />
      </Flex>
      {FilterNavItems.map((link) => (
        <NavItem key={link.name} icon={link.icon} path={link.path}>
          {link.name}
        </NavItem>
      ))}
    </Box>
  )
}

const NavItem = ({ icon, path, children, ...rest }: NavItemProps) => {
  const pathname = useLocation().pathname
  const isSelected = (path: string, option1: any, option2: any) => {
    return path === pathname ? option1 : option2;
  }

  return (
    <NavLink
      to={path}
    >
      <Flex
        align="center"
        p="4"
        mx="4"
        borderRadius="lg"
        role="group"
        cursor="pointer"
        _hover={{
          color: isSelected(path, 'white', 'brand.500'),
        }}
        color={
          isSelected(path, 'white', 'inherit')
        }
        bg={
          isSelected(path, 'brand.500', 'inherit')
        }
        fontWeight={
          isSelected(path, 'semibold', 'normal')
        }
        {...rest}
      >
        {icon && (
          <Icon
            mr="4"
            fontSize="16"
            _groupHover={{
              color: isSelected(path, 'white', 'inherit'),
            }}
            as={icon}
          />
        )}
        {children}
      </Flex>
    </NavLink>
  )
}

export default DefaultNav;
